import React from "react"
import PropTypes from "prop-types"
import { Button, Typography, Flex } from "antd"
import { RobotOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { GenericChartWidget } from "../widgets"
import AddChartPrompt from "./AddChartPrompt"
import styles from "../style.module.css"

const { Text } = Typography

export default function ChatMessage({ message, dispatch, onChartSaved, onChartDismiss, onWidgetSaved, onOptionSelect }) {
  const { t } = useTranslation()

  return (
    <div className={`${styles.chatMsg} ${message.sender === "user" ? styles.chatMsgUser : ""}`}>
      {message.sender === "ai" && (
        <div className={styles.dashAvatarSm}>
          <RobotOutlined className={styles.chatAvatarIconSm} />
        </div>
      )}
      <div className={styles.chatMsgInner}>
        <div className={`${styles.chatBubble} ${message.sender === "user" ? styles.chatBubbleUser : styles.chatBubbleAi}`}>
          {message.text}
        </div>
        {message.options?.items?.length > 0 && (
          <div className={styles.chatOptionTiles}>
            {message.options.items.map((opt) => (
              <button key={opt.value} className={styles.chatOptionTile} onClick={() => onOptionSelect?.(message.id, opt)}>
                {opt.label}
              </button>
            ))}
          </div>
        )}
        {message.chartPayload && (
          <>
            {message.chartPayload.chart_data != null && (
              <div className={styles.chatChartPreview}>
                <GenericChartWidget data={message.chartPayload} periodLabel="" />
              </div>
            )}
            <AddChartPrompt
              payload={message.chartPayload}
              dispatch={dispatch}
              onSaved={() => { onChartSaved(message.id); onWidgetSaved?.() }}
              onDismiss={() => onChartDismiss(message.id)}
            />
          </>
        )}
        {message.widgetSaved && (
          <Text type="secondary" className={styles.textSm}>✓ {t("ai_dashboard.chart_saved")}</Text>
        )}
        {message.actions && (
          <Flex wrap gap={6} className={styles.chatActions}>
            {message.actions.map((a) => (
              <Button key={a} size="small" className={styles.chatActionBtn}>{a}</Button>
            ))}
          </Flex>
        )}
        <Text type="secondary" className={styles.chatMsgTime}>{message.time}</Text>
      </div>
    </div>
  )
}

ChatMessage.propTypes = {
  message: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onChartSaved: PropTypes.func.isRequired,
  onChartDismiss: PropTypes.func.isRequired,
  onWidgetSaved: PropTypes.func,
  onOptionSelect: PropTypes.func,
}
